export const  calculateBrakingFriction = (speed) => {
    if(speed >= 10 && speed <= 40)       { return (-0.0059*speed + 0.8240);  }
    else if(speed > 40 && speed <= 50)   { return (-0.0059*speed + 0.8240);  }
    else if(speed > 50 && speed <= 60)   { return (-0.0039*speed + 0.7240);  }
    else if(speed > 60 && speed <= 70)   { return (-0.0034*speed + 0.6940);  }
    else if(speed > 70 && speed <= 80)   { return (-0.0022*speed + 0.6100);  }
    else if(speed > 80 && speed <= 90)   { return (-0.0018*speed + 0.5780);  }
    else if(speed > 90 && speed <= 100)  { return (-0.0015*speed + 0.5510);  }
    else if(speed > 100 && speed <= 130) { return (-0.0012*speed + 0.5210);  }
}